"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M11,2.66666667 L11,2.32124837 C11,1.21680684 10.1047419,0 9.00038502,0 L2.99961498,0 C1.88743329,0 1,0.895168718 1,1.99941529 L1,10.9890137 C1,12.0934552 1.89525812,12.988429 2.99961498,12.988429 L4,12.988429 L4,4.98791504 C4,3.88366846 4.88743329,2.98849975 5.99961498,2.98849975 L11,2.98849975 L11,2.66666667 Z M5,6.04016108 C5,4.93591451 5.88743329,4.04074579 6.99961498,4.04074579 L13.000385,4.04074579 C14.1047419,4.04074579 15,4.93571954 15,6.04016108 L15,14.0005847 C15,15.1048313 14.1125667,16 13.000385,16 L6.99961498,16 C5.89525812,16 5,15.1050262 5,14.0005847 L5,5.55497085 L5,6.04016108 Z"
  }));
};

exports["default"] = _default;